<template>
    <div>
        <el-dialog title="请选择收货地址" :visible.sync="addressPop" width="800px" class="dialog-header-border"
            @close="closePop"
        >
            <div class="address-page">
                <div class="header-wrap" v-if="list.length > 0">
                    <el-button type="primary" size="small" @click="addVisible = true">添加新地址</el-button>
                </div>
                
                <div class="main-wrap">
                    <div class="no-content" v-if="list.length == 0">
                        <i class="ic-empty"></i> 
                        <span class="text">暂无地址</span>
                        <br>
                        <el-button type="primary" size="small" @click="addVisible = true">添加新地址</el-button>
                    </div>
                    <div class="address-list" v-else>
                        <div class="item" v-for="item in list" :key="item.address_id">
                            <div class="check-box" :class="{act: checkedId == item.address_id}" @click="selectAddress(item)">
                                <i class="ic-check" v-show="checkedId == item.address_id"></i>
                            </div>
                            <div class="name-wrap">
                                <span class="name">{{item.address_contact_name}}</span>
                                <span class="phone">{{item.address_contact_phone}}</span>
                                <el-tag type="info" size="small" v-if="item.address_is_default=='y'">默认地址</el-tag>
                            </div>
                            <div class="detail">
                                {{item.region_province_string || ''}}
                                {{item.region_city_string || ''}}
                                {{item.region_district_string || ''}}
                                {{item.address_string || ''}}
                            </div>
                            <div class="btns">
                                <el-button type="text" @click="editAddress(item)">修改</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <address-add-model :visible.sync="addVisible" @on-success="onSuccess" />
        <address-edit-model :visible.sync="editVisible" :address-id="editAddressId" @on-success="onSuccess" />
    </div>
    
</template>

<script>
import { validateMobile } from '@/utils/validate.js'
import api from '@/api'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import addressAddModel from './addressAddModel'
import addressEditModel from './addressEditModel'

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        addressAddModel,
        addressEditModel
    },
    computed: {
        ...mapGetters(['userId'])
    },
    watch: {
        visible: function(val) {
            this.addressPop = val
        } 
    },
    data() {
        return {
            addVisible: false,
            editVisible: false,
            editAddressId: '',
            list: [],
            addressPop: false,
            checkedId: 437
        }
    },
    created() {
        this.getAddresList()
    },
    methods: {
        closePop() {
            this.$emit('update:visible', this.addressPop)
        },
        editAddress(item) {
            this.editVisible = true
            this.editAddressId = item.address_id
        },
        onSuccess() {
            this.getAddresList()
        },
        getAddresList() {
            request({
                url: api.requestUserAddressList,
                data: {
                    userId: this.userId,
                },
                loading: true
            }).then(res => {
                // console.log(res)
                if (res.errorCode == 200) {
                    this.list = res.data
                } else if (res.errorCode == -10005) {
                    this.list = []
                } else {
                    this.$message.error(res.errorMsg || '网络错误')
                }
            })
        },
        deleteAddress(item) {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                request({
					url: api.delUserAddress,
					data: {
                        addressId: item.address_id
                    }
				}).then(res => {
                    if (res.errorCode == 200) {
                        this.$message.success('删除成功')
                        this.getAddresList()
                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            })
        },
        selectAddress(item) {
            this.checkedId = item.address_id
            this.addressPop = false
            this.$emit('get-address', item)
        }
    }
}
</script>

<style lang="scss" scoped>
.address-page {
    margin: 0 auto;
    width: 100%;
    .header-wrap {
        text-align: right;
    }
    .main-title {
        font-size: 24px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
    }
    .main-wrap {
        margin-top: 16px;
        padding: 0 24px 0 0px;
        background: #FFFFFF;
        border-radius: 2px;
    }
    .no-content {
        padding: 60px 0 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #ccc;
        .ic-empty {
            width: 88px;
            height: 64px;
            background: url(../../../assets/icons/icon_empty.png) no-repeat;
            background-size: cover;;
        }
        .text {
            margin-top: 8px;
            font-size: 14px;
        }
    }
    .address-list {
        .item {
            padding: 24px 0 24px 32px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            position: relative;
            &:last-child {
                border-bottom: none;
            }
            .phone {
                margin-left: 24px;
                margin-right: 40px;
            }
            .detail {
                width: 60%;
                margin-top: 8px;
            }
            .btns {
                position: absolute;
                top: 38px;
                right: 0;
            }
            .check-box {
                position: absolute;
                top: 40px;
                left: 0;
                width: 18px;
                height: 18px;
                border-radius: 50%;
                border: 1px solid #999;
                font-size: 20px;
                text-align: center;
                line-height: 24px;
                overflow: hidden;
                cursor: pointer;
                .ic-check {
                    display: block;
                    width: 10px;
                    height: 10px;
                    background: #3F33FF;
                    margin: 4px auto;
                    border-radius: 50%;
                }
                &.act {
                    border-color: #3F33FF;
                    color: #3F33FF;
                }
                &:hover {
                    border-color: #3F33FF;
                }
            }
        }
    }
    .add-address-wrap {
        width: 700px;
    }
}
</style>